export default "__VITE_ASSET__CQN7m36r__"